// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"043e33ee","457":"4626ba69"}[chunkId] + ".chunk.js";
};